import { RootState } from '~/store';

const selectPromotion = (state: RootState) => state.promotion.promotion;

export default selectPromotion;
